import { CrmNoteType } from '@plato/data/prisma';
import { keepPreviousData } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ActivityFeedModelType } from '../../../server/types/customer-activity-feed-types.ts';
import { api } from '../../../utils/api.ts';
import { useActivityFilters } from './use-activity-filters.ts';

export function useActivityPinnedNotes(customerId?: string) {
    const { appliedFilters } = useActivityFilters();

    const modelType = appliedFilters.modelType;
    const searchText = appliedFilters.searchText ?? '';
    const hasOtherFilters = [
        appliedFilters.orderStatuses,
        appliedFilters.quoteStatuses,
        appliedFilters.taskStatuses,
    ].some((value) => !!value?.length);

    const noteTypes = useMemo(() => appliedFilters.noteTypes ?? [], [appliedFilters.noteTypes]);

    const isEnabled =
        !!customerId &&
        (!modelType || modelType === ActivityFeedModelType.NOTE) &&
        (!!modelType || !hasOtherFilters || noteTypes.length > 0) &&
        (noteTypes.length === 0 || noteTypes.includes(CrmNoteType.NOTE));

    const filters = useMemo(() => {
        return {
            customerId: customerId ?? '',
            searchText,
            noteTypes,
        };
    }, [customerId, searchText, noteTypes]);

    const queryResult = api.platoUser.query.customerActivity.getFeedList.getPinnedNotes.useQuery(filters, {
        enabled: isEnabled,
        placeholderData: keepPreviousData,
    });

    return {
        ...queryResult,
        isLoading: isEnabled && queryResult.isLoading,
        isEnabled,
        notes: isEnabled ? queryResult.data || [] : [],
    };
}
